export const GET_JOB_LISTING_QUESTION_TEMPLATES = gql`
  query getJobListingQuestionTemplates(
    $jobListingId: String!
    $voiceAgentId: String
  ) {
    jobListingQuestionTemplates(
      jobListingId: $jobListingId
      voiceAgentId: $voiceAgentId
    ) {
      jobListingId
      questionTemplateId
      voiceAgentId
      createdAt
      order
      operator
      comparisonValue
      status
      disqualifier
      questionTemplate {
        questionTemplateId
        question
        variableName
        shortQuestionName
        variableType
        condition
        disqualifiedReason
      }
      voiceAgent {
        voiceAgentId
        name
      }
    }
  }
`

export const ADD_JOB_LISTING_QUESTION_TEMPLATE = gql`
  mutation addJobListingQuestionTemplate(
    $input: AddJobListingQuestionTemplateInput!
  ) {
    addJobListingQuestionTemplate(input: $input) {
      jobListingId
      questionTemplateId
      voiceAgentId
      createdAt
      order
      operator
      comparisonValue
      status
      disqualifier
      questionTemplate {
        questionTemplateId
        question
        variableName
        shortQuestionName
        variableType
        condition
        disqualifiedReason
      }
      voiceAgent {
        voiceAgentId
        name
      }
    }
  }
`

export const UPDATE_JOB_LISTING_QUESTION_TEMPLATE = gql`
  mutation updateJobListingQuestionTemplate(
    $jobListingId: String!
    $questionTemplateId: String!
    $input: UpdateJobListingQuestionTemplateInput!
  ) {
    updateJobListingQuestionTemplate(
      jobListingId: $jobListingId
      questionTemplateId: $questionTemplateId
      input: $input
    ) {
      jobListingId
      questionTemplateId
      voiceAgentId
      createdAt
      order
      operator
      comparisonValue
      status
      disqualifier
      questionTemplate {
        questionTemplateId
        question
        variableName
        shortQuestionName
        variableType
        condition
        disqualifiedReason
      }
      voiceAgent {
        voiceAgentId
        name
      }
    }
  }
`

export const REMOVE_JOB_LISTING_QUESTION_TEMPLATE = gql`
  mutation removeJobListingQuestionTemplate(
    $jobListingId: String!
    $questionTemplateId: String!
  ) {
    removeJobListingQuestionTemplate(
      jobListingId: $jobListingId
      questionTemplateId: $questionTemplateId
    ) {
      jobListingId
      questionTemplateId
      status
    }
  }
`

export const REORDER_JOB_LISTING_QUESTION_TEMPLATES = gql`
  mutation reorderJobListingQuestionTemplates(
    $input: ReorderJobListingQuestionTemplatesInput!
  ) {
    reorderJobListingQuestionTemplates(input: $input) {
      jobListingId
      questionTemplateId
      voiceAgentId
      order
      questionTemplate {
        questionTemplateId
        question
        variableName
        shortQuestionName
        variableType
      }
      voiceAgent {
        voiceAgentId
        name
      }
    }
  }
`
